export default "__VITE_ASSET__uyKe6OXc__"